export default __webpack_public_path__ + "static/media/Abyss3.53fa52da.jpg";